import { useSettings } from '@/settings/settings';
import { useReducedMotion } from './useReducedMotion';

/**
 * Resolves the effective reduced-motion flag by layering the user's explicit
 * motion preference over the OS setting. Returns true when animations should be
 * suppressed.
 *
 * - `settings.motion === 'reduce'`  → always true (regardless of OS)
 * - `settings.motion === 'full'`    → always false (override even if OS says reduce)
 * - `settings.motion === 'system'`  → follows prefers-reduced-motion (default)
 */
export function useMotionReduced(): boolean {
  const systemReduced = useReducedMotion();
  const { settings } = useSettings();
  if (settings.motion === 'reduce') return true;
  if (settings.motion === 'full') return false;
  return systemReduced;
}
